import { ReactNode } from 'react';
import IForm, { IFormProps } from '../i-form/i-form.component';

type ISearchProps = {
  children: ReactNode;
  search?: any;
}

const SearchPanel = (props: ISearchProps & IFormProps) => {

  const onSubmit = (data: any) => {
    props.search(data)
  }

  return <IForm {...props} submitForm={onSubmit} mainComponent={props.children}
    showCancelBtn={false} showResetBtn={false} saveButtonText={'Search'} 
    showExportBtn={props.showExportBtn} export={props.export}></IForm>
}

export default SearchPanel;